import { HttpErrorResponse } from "@angular/common/http";

export class HttpConnectorError extends Error {

    response: HttpErrorResponse;
    method: string;

    constructor(response: HttpErrorResponse, method: string) {
        super(response?.message);
        this.response = response;
        this.method = method;
    }
}